import { useContext } from 'react'
import { ClientPreferencesContext } from '../../context/clientPreferencesContextCore'

export function useLoadingStyle(): 'constellation' | 'starfield' {
  const ctx = useContext(ClientPreferencesContext)
  if (ctx && ctx.preferences && ctx.preferences.loadingStyle) {
    return ctx.preferences.loadingStyle === 'STARFIELD' ? 'starfield' : 'constellation'
  }
  if (typeof document !== 'undefined' && document.documentElement) {
    const attr = document.documentElement.getAttribute('data-loading-style')
    if (attr === 'starfield') return 'starfield'
    if (attr === 'constellation') return 'constellation'
  }
  return 'constellation'
}

export function prefersStill(): boolean {
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return true
      }
    } catch {
      // Guard missing or invalid matchMedia implementations
    }
  }
  if (typeof document !== 'undefined' && document.documentElement) {
    if (document.documentElement.getAttribute('data-animation-profile') === 'reduced') {
      return true
    }
  }
  return false
}
